import { css } from 'styled-components';
import { BackdropProps } from './models';

export const Backdrop = css<BackdropProps>(({ theme }) => {
  return css`
    overflow-y: auto;
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;

    > .backdrop-layer {
      position: fixed;
      height: 100%;
      width: 100%;
      z-index: -1;
      transition: background-color 0.2s;
    }
  `;
});
